import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { ElderShellService } from '@elderbyte/ngx-starter'
import { Action } from '../action'
import { ActionDetailComponent } from '../action-detail/action-detail.component'

@Component({
  selector: 'app-action-detail-side',
  templateUrl: './action-detail-side.component.html',
  styleUrls: ['./action-detail-side.component.scss'],
  imports: [ActionDetailComponent],
})
export class ActionDetailSideComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public action: Action
  private shellService = inject(ElderShellService)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const route = inject(ActivatedRoute)
    this.action = route.snapshot.data['action']
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public onClose(event: Event): void {
    this.shellService.closeSideContent()
  }
}
